export const FETCH_ALL = "arearequests_List";

export const FETCH = "arearequests_FindById";

export const CREATE = "arearequests_CreateOne";

export const EDIT = "arearequests_UpdateById";

export const DELETE = "arearequests_RemoveManyByIds";


